<template>
  <div class="sitemap-wrapper">
    <div class="info-content">
      <BreadcrumbNavigation class="crumb-margin" />
      <div class="layout_contents">
        <div class="label-title">{{ $t('footer.siteMap') }}</div>
        <!-- Area Site -->
        <div v-for="page in pageList" :key="page.path" class="area-site">
          <p class="label-site">{{ page.name }}</p>
          <ul class="list-site">
            <template v-if="page.path !== '/support' && page.path !== '/duty-free' && page.children">
              <li v-for="subPage in page.children" :key="subPage.path">
                <span class="txt-label"> {{ subPage.name }}</span>
                <ul class="list-sub">
                  <template v-if="subPage.children">
                    <li v-for="depth in subPage.children" :key="depth.path">
                      <div class="menu" @click="goToPage(depth.path, depth.link)">{{ depth.name }}</div>
                    </li>
                  </template>
                  <template v-else>
                    <li>
                      <div class="menu" @click="goToPage(subPage.path, subPage.link)">{{ subPage.name }}</div>
                    </li>
                  </template>
                </ul>
              </li>
            </template>

            <template v-else-if="page.path === '/support' || page.path === '/duty-free'">
              <li>
                <span class="txt-label"> {{ page.name }} </span>
                <ul class="list-sub">
                  <li v-for="subPage in page.children" :key="subPage.path">
                    <div class="menu" @click="goToPage(subPage.path, subPage.link)">{{ subPage.name }}</div>
                  </li>
                </ul>
              </li>
            </template>

            <template v-else>
              <li>
                <span class="txt-label"> {{ page.name }} </span>
                <ul class="list-sub">
                  <li>
                    <div class="menu" @click="goToPage(page.path, page.link)">{{ page.name }}</div>
                  </li>
                </ul>
              </li>
            </template>
          </ul>
        </div>
        <!-- //Area Site -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadcrumbNavigation from '@/components/common/BreadcrumbNavigation.vue';

export default {
  name: 'SiteMap',
  components: { BreadcrumbNavigation },
  computed: {
    ...mapGetters('common', ['globalNav']),
    pageList() {
      const pageList = this.globalNav.filter(item => item.path !== '/site-map');
      return pageList;
    },
  },
  methods: {
    goToPage(path, link) {
      if (link) {
        window.open(link, '_blank');
        return;
      }
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.sitemap-wrapper {
  width: 100%;
  padding-top: 24px;
}

.info-content {
  width: 100%;
  max-width: 1384px;
  display: flex;
  flex-direction: column;
  gap: 60px;
  margin: 0 auto 100px auto;
}

.crumb-margin {
  margin-left: 16px;
}

.layout_contents {
  width: 100%;
  padding: 0 16px;
  margin: 0 auto;
}

.label-title {
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 60px;
}

.area-site + .area-site {
  margin-top: 60px;
}

.area-site .label-site {
  padding-bottom: 20px;
  font-size: 28px;
  line-height: 36px;
  font-weight: 700;
}

.list-site {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.list-site > li {
  width: calc(100% / 3 - 40px);
}

.list-site > li > .txt-label {
  display: block;
  background: #f5f7f9;
  padding: 17px 20px;
  color: #686d72;
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
}

.list-site .list-sub > li > .menu {
  position: relative;
  display: block;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  padding: 15px 20px;
  color: #686d72;
  background: url(@/assets/images/icon/arrow_right-navigation_icon_gray.svg) no-repeat right 19px center;
  cursor: pointer;
}

.list-site .list-sub > li > .menu:hover {
  color: var(--Blue-blue-500);
  background: url(@/assets/images/icon/arrow_right-navigation_icon_blue.svg) no-repeat right 19px center;
}

@media (max-width: 767px) {
  .label-title {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 24px;
  }
  .area-site .label-site {
    font-size: 22px;
    line-height: 36px;
    padding-bottom: 12px;
  }
  .list-site .list-sub > li > .menu,
  .list-site > li > .txt-label {
    padding: 12px 20px;
    font-size: 16px;
    line-height: 30px;
  }
  .area-site + .area-site {
    margin-top: 24px;
  }
  .list-site {
    flex-direction: column;
    gap: 12px;
  }
  .list-site > li {
    width: 100%;
  }
  .list-site > li + li {
    margin-left: 0;
    margin-top: 12px;
  }
}
</style>
